import { useQuery } from 'react-query';
import api from '../../utils/andromeda-api';

// params: { start, end, search, statuses, ids, page, size }
// Returns { result: Message[], pagination: { page, size, total } }.
export const getMessagesV2 = async (orgId, params) => {
  const response = await api.get(`/analytics-v2/messages/${orgId}`, {
    params,
  });
  return response.data;
};

export const useMessagesV2Query = (orgId, params, options) =>
  useQuery(
    ['analytics-v2', 'messages', orgId, params],
    () => getMessagesV2(orgId, params),
    { keepPreviousData: true, ...options }
  );

// One message by id, from the list endpoint. Returns the message, or null
// when it is not in the organization.
export const useMessageV2Query = (orgId, messageId) =>
  useQuery(['analytics-v2', 'message', orgId, messageId], async () => {
    const { result } = await getMessagesV2(orgId, { ids: messageId });
    return result[0] || null;
  });

// Per-day counts for one message. params: { start, days }
// Returns { days: [{ day, email, text, versionB?, smartResend? }] }.
export const getMessageDailyV2 = async (orgId, messageId, params) => {
  const response = await api.get(
    `/analytics-v2/messages/${orgId}/${messageId}/daily`,
    { params }
  );
  return response.data;
};

export const useMessageDailyV2Query = (orgId, messageId, params, options) =>
  useQuery(
    ['analytics-v2', 'daily', orgId, messageId, params],
    () => getMessageDailyV2(orgId, messageId, params),
    options
  );

// Per-day counts for several messages. params: { start, days }
// Returns { [messageId]: [{ day, email, text, versionB?, smartResend? }] }.
export const useMessagesDailyV2Query = (orgId, ids, params, options) =>
  useQuery(
    ['analytics-v2', 'daily-combined', orgId, ids, params],
    async () => {
      const response = await api.get(`/analytics-v2/messages/${orgId}/daily`, {
        params: { ids: ids.join(','), ...params },
      });
      return response.data.messages;
    },
    options
  );

// Drawer rows for several messages. kind: 'deliveries', 'opens', 'clicks' or
// 'errors'. params: { ids (array), channel, type, search, page, size,
// export }. Returns { result, pagination: { page, size, total } }, or just
// { result } with every row when export is true.
export const getCombinedDrawerRows = async (orgId, kind, params) => {
  const response = await api.get(`/analytics-v2/messages/${orgId}/${kind}`, {
    params: { ...params, ids: params.ids.join(',') },
  });
  return response.data;
};
